"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHealthSystemFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M9 18.007H4.014C2.671 18.007 2 17.342 2 16.01v-1.995h7.103A5.006 5.006 0 0013 17.9v.1c0 1.635.785 3.087 1.998 4H7c-.667 0-1-.334-1-.999 0-.666.333-.998 1-.998h1l1-1.996zM2 12.018h7V10a5 5 0 015-5c.768 0 1.47.289 2 .764A2.989 2.989 0 0118 5c1.636 0 3.088.785 4 2V4.033c0-1.322-.653-1.988-1.96-1.998-8.563-.068-13.757-.02-15.583-.002L4 2.037c-1.333.01-2 .674-2 1.996v7.985z' }),
    react_1.default.createElement("path", { d: 'M11.176 14.015A3.001 3.001 0 0014 16h1V18.006A3 3 0 0018 21h.268A2 2 0 0022 20a2 2 0 00-3.732-1H18a1 1 0 01-1-.994V16h1a3.001 3.001 0 003-3v-3a3 3 0 00-3-3 1 1 0 100 2 1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3a1 1 0 011-1 1 1 0 100-2 3 3 0 00-3 3v3c0 .356.062.698.176 1.015z' }))); };
exports.default = SvgHealthSystemFilled;
//# sourceMappingURL=HealthSystemFilled.js.map